export default "__VITE_ASSET__BNIV2ctX__"